// src/socket/QuerySocketManager.js
import { io } from "socket.io-client";
import config from "../config/config";

class NotificationSocketManager {
  constructor() {
    this.sockets = {}; // key: notification
    this.key = "notification"
  }

  _getRoomKey() {
    return this.key
  }

  connect(token, onConnect = null) {
    const key = this._getRoomKey();
    if (this.sockets[key]) return this.sockets[key];

    const socket = io(`${config["backend-url"]}/notification`, {
      transports: ["websocket"],
    });

    this.sockets[key] = socket;

    socket.on("connect", () => {
      console.log(`✅ Connected to /query for room [${key}]`);
      socket.emit("join_group", { token });

      if (onConnect) onConnect(socket); // ✅ Call once connected

    });

    socket.on("disconnect", () => {
      console.warn(`⚠️ Disconnected from room [${key}]`);
    });

    socket.on("status", (data) => {
      console.log(`ℹ️ Status for [${key}]:`, data.msg);
    });

    socket.on("error", (err) => {
      console.error(`❌ Socket error in [${key}]:`, err.error || err);
    });

    return socket;
  }

  disconnect() {
    const key = this._getRoomKey();
    if (this.sockets[key]) {
      this.sockets[key].disconnect();
      delete this.sockets[key];
      console.log(`❎ Fully disconnected from room [${key}]`);
    }
  }

  leaveRoom(token) {
    const key = this._getRoomKey();
    if (this.sockets[key]) {
      this.sockets[key].emit("leave_group", { token });
      console.log(`🚪 Left room [${key}]`);
    }
  }

  on(event, handler) {
    const key = this._getRoomKey();
    console.log(`🔊 Listening for event [${event}] in room [${key}]`);
    if (this.sockets[key]) {
      this.sockets[key].on(event, handler);
    }
  }

  off(event) {
    const key = this._getRoomKey();
    if (this.sockets[key]) {
      this.sockets[key].off(event);
    }
  }
}

const notificationSocketManager = new NotificationSocketManager();
export default notificationSocketManager;
